import { createBrowserRouter, Navigate, redirect } from 'react-router';
import { AppShell } from './components/layout/AppShell';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import { LoginPage } from './pages/LoginPage';
import { OAuthCallbackPage } from './pages/OAuthCallbackPage';
import { OrdersPage, ordersLoader } from './pages/OrdersPage';
import { BatchesPage, batchesLoader } from './pages/BatchesPage';
import { BatchDetailPage, batchDetailLoader } from './pages/BatchDetailPage';
import { SettingsPage, settingsLoader } from './pages/SettingsPage';
import { LumiCodePage, lumiCodeLoader } from './pages/LumiCodePage';
import { DonePage, doneLoader } from './pages/DonePage';
import { ManualOrderPage, manualOrderLoader } from './pages/ManualOrderPage';
import { fetchSession } from './lib/api';

async function requireSessionLoader() {
  const me = await fetchSession();
  if (!me.user) throw redirect('/signin');
  return { user: me.user };
}

export const router = createBrowserRouter([
  { path: '/signin', element: <LoginPage /> },
  { path: '/auth/callback', element: <OAuthCallbackPage /> },
  {
    path: '/',
    loader: requireSessionLoader,
    element: <AppShell />,
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="/orders" replace /> },
      { path: 'orders', element: <OrdersPage />, loader: ordersLoader },
      { path: 'manual-order', element: <ManualOrderPage />, loader: manualOrderLoader },
      { path: 'batches', element: <BatchesPage />, loader: batchesLoader },
      { path: 'batches/:code', element: <BatchDetailPage />, loader: batchDetailLoader },
      { path: 'settings', element: <SettingsPage />, loader: settingsLoader },
      { path: 'lumi-code', element: <LumiCodePage />, loader: lumiCodeLoader },
      { path: 'done', element: <DonePage />, loader: doneLoader },
    ],
  },
]);
